import { Box, Typography } from '@mui/material';
import { FC, PropsWithChildren, ReactNode } from 'react';

interface Props extends PropsWithChildren {
  label: ReactNode;
}

export const DisplayBox: FC<Props> = ({ label, children }) => {
  return (
    <Box
      sx={{
        border: 2,
        borderRadius: 1,
        px: 3,
        py: 1,
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        alignItems: 'center',
      }}
    >
      <Typography fontWeight="medium">{label}</Typography>
      <Typography
        fontWeight="medium"
        sx={{ bgcolor: '#35404A', borderRadius: 1, px: 2, textAlign: 'center', py: 1 / 4 }}
      >
        {children}
      </Typography>
    </Box>
  );
};
